import { useNavigate } from '@tanstack/react-router';
import type { PromoAdjustmentUnit, PromoDrillParams } from '../types/promotion.types';

export function usePromoAdjustmentNavigation(unit: PromoAdjustmentUnit) {
  const navigate = useNavigate();

  function openAdjustmentList(zmSearch: PromoDrillParams) {
    if (unit === 'marketPromotion') {
      void navigate({ to: '/market-promotion/adjustment', search: zmSearch });
      return;
    }
    void navigate({ to: '/promotion/adjustment', search: zmSearch });
  }

  function openItemZms(promoItemId: number, zmSearch: PromoDrillParams) {
    if (unit === 'marketPromotion') {
      void navigate({
        to: '/market-promotion/adjustment/$promoItemId',
        params: { promoItemId },
        search: zmSearch,
      });
      return;
    }
    void navigate({
      to: '/promotion/adjustment/$promoItemId',
      params: { promoItemId },
      search: zmSearch,
    });
  }

  return { openAdjustmentList, openItemZms };
}
